<template>
  <div class="role">
    <Header :present-page="presentPage" />
    <a-row class="warp">
      <a-col :span="16">
        <a-row class="top">
          <a-col class="ipt">
            <span>角色名称</span>
            <a-input
              v-model:value="roleName"
              placeholder="请输入"
            />
          </a-col>
          <a-col class="operate">
            <a-button
              type="primary"
              @click="search"
            >搜索</a-button>
            <a-button
              type="default"
              @click="reset"
            >重置</a-button>
            <a-button
              type="default"
              @click="addModalShow"
            >添加</a-button>
          </a-col>
          <!-- <a-col>
            <a-dropdown
              :placement="placement"
              :trigger="['click', 'hover']"
            >
              <a
                class="ant-dropdown-link"
                @click.prevent
              >
                <a-button>更多操作</a-button>
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item @click="addModalShow">
                    <a href="javascript:;">添加</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </a-col> -->
        </a-row>
        <a-table
          rowKey="roleId"
          :columns="columns"
          :data-source="dataSource"
          :pagination="pagination"
          @change="change"
        >
          <template #action="{ record }">
            <a-button
              class="alter"
              @click="alterModalShow(record)"
            >修改</a-button>
            <a-button
              class="del"
              @click="delModalShow(record.roleId)"
            >删除</a-button>
          </template>
        </a-table>
      </a-col>
      <a-col
        class="right"
        :span="8"
      >
        <AddRole
          ref="AddRole"
          :menu-list="treeData"
          @confirm="init"
        />
        <AlterRole
          ref="AlterRole"
          :menu-list="treeData"
          :alter-data="alterData"
          @confirm="init"
        />
        <DelModal
          ref="DelModal"
          @confirm="confirmDel"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import AddRole from "@/components/system/role/add.vue";
import AlterRole from "@/components/system/role/alter.vue";
import DelModal from "@/components/delModal.vue";
import { roleList, delRole, menuList } from "@/api/system/system.js";

export default {
  name: "Role",
  components: {
    Header,
    AddRole,
    AlterRole,
    DelModal
  },
  data() {
    return {
      presentPage: '',
      roleName: '',
      placement: 'bottomCenter',
      pagination: {
        size: 'small',
        showSizeChanger: true,
        showQuickJumper: true,
        pageSize: 10,
        showTotal: total => `共 ${total} 条`,
        total: 0
      },
      selectedRowKeys: [],
      query: {
        pageNum: 1,
        pageSize: 10
      },
      delQuery: {
        roleIds: ''
      },
      columns: [
        {
          title: '角色名称',
          dataIndex: 'roleName',
        },
        {
          title: '角色描述',
          dataIndex: 'remark',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          slots: {
            customRender: 'action',
          },
        },
      ],
      dataSource: [],
      treeData: [],
      alterData: {}
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
    this.init()
    menuList(this.query).then(res => {
      if (res.code == 200) {
        this.treeData = res.data.menuTree
        // console.log(this.treeData)
      }
    }).catch(res => {
      console.log(res)
    });
  },
  methods: {
    init() {
      roleList(this.query).then(res => {
        if (res.code == 200) {
          this.dataSource = res.data.list
          this.pagination.pageSize = res.data.pageSize
          this.pagination.total = res.data.total
        }
      }).catch(res => {
        console.log(res)
      });
    },
    search() {
      this.query.filterDate = this.roleName
      this.init()
    },
    reset() {
      this.roleName = ''
      this.search()
    },
    addModalShow() {
      this.$refs.AlterRole.hide();
      this.$refs.AddRole.show();
    },
    alterModalShow(record) {
      this.alterData = JSON.parse(JSON.stringify(record))
      this.$refs.AddRole.hide();
      this.$refs.AlterRole.show();
    },
    delModalShow(roleId) {
      this.delQuery = {
        roleIds: roleId
      }
      this.$refs.DelModal.show();
    },
    confirmDel() {
      delRole(this.delQuery).then(res => {
        if (res.code == 200) {
          this.init()
          this.$message.success(res.data);
        }
      }).catch(res => {
        console.log(res)
      });
    },
    change(pagination) {
      // console.log(pagination)
      this.query = {
        pageNum: pagination.current,
        pageSize: pagination.pageSize
      }
      this.init()
    }
  }
};
</script>
<style scoped>
.warp {
  margin: 20px 30px;
}
.top {
  height: 76px;
  margin: 0 20px 0 0;
  padding: 20px 30px;
  line-height: 36px;
  background: #fff;
}

.ipt {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.ipt span {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ant-divider-vertical {
  height: 22px;
  margin: 0 15px;
  background: #dddddd;
}
.ant-select :deep() .ant-select-selector {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 34px;
  line-height: 34px;
}
.operate {
  text-align: left;
}
.operate button:nth-child(1),
.operate button:nth-child(3) {
  width: 80px;
  height: 36px;
  margin: 0 20px;
  color: #fff;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.operate button:nth-child(2) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.ant-dropdown-link button {
  height: 36px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}

.ipt :deep() .ant-calendar-picker {
  width: 236px;
}
.ipt :deep() .ant-calendar-picker-input {
  width: 100%;
  height: 36px;
  border-radius: 6px;
}
.ant-table-wrapper {
  margin: 0 20px 0 0;
}
.ant-table-wrapper :deep() .ant-table-thead > tr > th,
.ant-table-wrapper :deep() .ant-table table {
  text-align: center;
}
.ant-table-wrapper .ant-btn {
  width: 66px;
  height: 24px;
  padding: 0;
  margin: 0 5px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  border-radius: 4px;
}
.look,
.alter {
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
}
.del {
  color: #ff4444;
  background: #fff;
  border: 1px solid #ff4444;
}
.right {
  padding: 22px;
  background: #fff;
}
.right :deep() h5 {
  padding-left: 10px;
  text-align: left;
  vertical-align: top;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222;
  border-left: 5px solid #0088ff;
}
.right :deep() .ipt {
  align-items: flex-start;
}
.right :deep() .ipt input {
  width: 100%;
}
.right :deep() .a-btn {
  text-align: right;
}
.right :deep() .ant-form-item-label > label::after {
  content: " ";
}
.right :deep() .cancel {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.right :deep() .confirm {
  width: 80px;
  height: 36px;
  color: #fff;
  border: 0;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
</style>
